import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type EditButtonWithLabelClasses = 'stickyEditButton' | 'editLabel';

const editButtonWithLabelStyles = makeStyles<ISpcTheme, EditButtonWithLabelClasses>(
  theme => ({
    stickyEditButton: {
      marginBottom: 0,
    },
    editLabel: {
      fontSize: theme.typography.fontXS,
      fontFamily: theme.typography.fontFamily2,
      color: theme.palette.primary.main,
      paddingRight: theme.spacing(0.5),
    },
  }),
  { name: 'Common_EditButtonWithLabel' },
);

export default editButtonWithLabelStyles;
